import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  'keji-shuma': 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20technology%20products%20display%20with%20smartphones%20and%20gadgets%2C%20clean%20minimalist%20showroom%2C%20bright%20professional%20lighting%2C%20warm%20atmosphere&width=800&height=500&seq=cat-keji-01&orientation=landscape',
  'jiadian': 'https://readdy.ai/api/search-image?query=Modern%20home%20appliances%20display%20with%20smart%20kitchen%20devices%2C%20clean%20minimalist%20interior%2C%20bright%20warm%20lighting%2C%20professional%20product%20photography&width=800&height=500&seq=cat-jiadian-02&orientation=landscape',
  'meizhuang': 'https://readdy.ai/api/search-image?query=Chinese%20luxury%20cosmetics%20display%20with%20elegant%20traditional%20patterns%2C%20soft%20warm%20lighting%2C%20delicate%20product%20photography%2C%20oriental%20aesthetics&width=800&height=500&seq=cat-meizhuang-03&orientation=landscape',
  'shipin-yinliao': 'https://readdy.ai/api/search-image?query=Chinese%20premium%20food%20and%20beverage%20products%20display%2C%20elegant%20packaging%2C%20warm%20natural%20lighting%2C%20professional%20product%20photography%2C%20clean%20composition&width=800&height=500&seq=cat-shipin-04&orientation=landscape',
  'fushi-xiebao': 'https://readdy.ai/api/search-image?query=Chinese%20fashion%20brand%20clothing%20display%20with%20modern%20design%2C%20elegant%20retail%20space%2C%20warm%20professional%20lighting%2C%20clean%20minimalist%20photography&width=800&height=500&seq=cat-fushi-05&orientation=landscape',
  'qiche': 'https://readdy.ai/api/search-image?query=Chinese%20electric%20vehicles%20modern%20showroom%20display%2C%20sleek%20futuristic%20design%2C%20bright%20professional%20lighting%2C%20automotive%20photography%20warm%20atmosphere&width=800&height=500&seq=cat-qiche-06&orientation=landscape',
  'jiaju-baihuo': 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20home%20furniture%20and%20lifestyle%20products%20display%2C%20clean%20minimalist%20interior%2C%20warm%20natural%20lighting%2C%20professional%20photography&width=800&height=500&seq=cat-jiaju-07&orientation=landscape',
  'wenchuang': 'https://readdy.ai/api/search-image?query=Chinese%20cultural%20creative%20products%20and%20designer%20toys%20display%2C%20colorful%20traditional%20patterns%2C%20bright%20creative%20lighting%2C%20playful%20atmosphere&width=800&height=500&seq=cat-wenchuang-08&orientation=landscape',
};

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            品牌分类
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            探索国产品牌世界
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            八大品类覆盖中国自主品牌全领域，助您快速找到心仪的国货精品
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 h-40 md:h-48"
            >
              <img
                src={categoryImages[cat.slug] || categoryImages['keji-shuma']}
                alt={`${cat.name} - 国产品牌分类`}
                title={`${cat.name} - 国产好物推荐`}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-7 h-7 flex items-center justify-center">
                    <i className={`${cat.icon} text-background-50 text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-bold text-background-50">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs text-background-200 hidden sm:block line-clamp-1">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}